var _style, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRssFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "RSSicon",
    viewBox: "0 0 8 8",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".symbol{stroke:none;fill:#fff}")), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1.5,
    style: {
      stroke: "none",
      fill: "#fe6500"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "symbol",
    cx: 2,
    cy: 6,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "M1 4a3 3 0 0 1 3 3h1a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "M1 2a5 5 0 0 1 5 5h1a6 6 0 0 0-6-6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssFeed);
export default __webpack_public_path__ + "static/media/RSS_Feed.abe28256b892dc52382dcb63177581e0.svg";
export { ForwardRef as ReactComponent };